import React from 'react';
import { connect } from 'react-redux';
import { loadNetworks, loadSdkKey, loadSafedkKey } from '../redux/actions';
import { STATE_MEDIATION_DOCS } from '../redux/constants';
import MediationDocsComponent from '../components/common/MediationDocsComponent';

const mapStateToProps = state =>
    ( {
        networks: state[ STATE_MEDIATION_DOCS ].networks,
        sdkKey: state[ STATE_MEDIATION_DOCS ].sdkKey,
        safedkKey: state[ STATE_MEDIATION_DOCS ].safedkKey,
    } );

const mapDispatchToProps = dispatch =>
    ( {
        loadNetworks: () => dispatch( loadNetworks() ),
        loadSdkKey: () => dispatch( loadSdkKey() ),
        loadSafedkKey: () => dispatch( loadSafedkKey() ),
    } );

const MediationDocsContainer = props => <MediationDocsComponent {...props}/>;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( MediationDocsContainer );
